/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Params } from '@angular/router';

export interface DomainOptionsModel {
  /**
   * flag per abilitare l'utilizzo della cache (di default è abilitato)
   */
  fromCache?: boolean;

  /**
   * ms di ritardo da applicare alla chiamata risolta dalla cache;
   * è utile per evitare aggiornamenti dei template troppo rapidi
   * che potrebbero causare errori di ExpressionChangedAfterItHasBeenCheckedError
   */
  cacheDelay?: number;

  /**
   * valore filtro applicato alla chiamata
   */
  filter?: string;

  /**
   * parametri http aggiuntivi
   */
  params?: Params;
}
